import React from 'react';
import { Button } from 'reactstrap';

import {
	PenBlackIcon,
	TrashBlackIcon,
} from 'src/assets/images/job-details-slide-out/job-details-slide-out';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux-hooks';
import { updateVisibility } from 'src/redux/modals/slice';

export const ResidentResponsibility: React.FC = () => {
	const residentCaused = useAppSelector(
		(state) => state?.jobDetails?.data?.resident_caused,
	);
  const rootNodeId = useAppSelector(
		(state) => state?.jobDetails?.data?.root_node_id,
	);
	const dispatch = useAppDispatch();

	const onClickMarkResidentResponsibility = () => {
		dispatch(
			updateVisibility({
				modalType: 'residentResponsibilityModal',
				isVisible: true,
				extraProps: { mode: 'mark', rootNodeId },
			}),
		);
	};

	const onClickEditResidentResponsibility = (jobId: number) => {
		dispatch(
			updateVisibility({
				modalType: 'residentResponsibilityModal',
				isVisible: true,
				extraProps: {
					mode: 'edit',
          rootNodeId,
					jobId,
				},
			}),
		);
	};

	const onClickRemoveResidentResponsibility = (jobId: number) => {
		dispatch(
			updateVisibility({
				modalType: 'residentResponsibilityRemoveModal',
				isVisible: true,
				extraProps: {
          rootNodeId,
					jobId,
				},
			}),
		);
	};

	const hasAnyYes = residentCaused?.some((rc) => rc.value === 'yes');
	const visibleCauses = hasAnyYes
		? residentCaused?.filter((residentCause) => residentCause.value === 'yes')
		: residentCaused;

	return (
		<React.Fragment>
			{!residentCaused || residentCaused?.length === 0 ? (
				<div className="resident-responsibility">
					<Button
						type="button"
						color="none"
						className="grey-outline-btn resident-responsibility__mark-btn"
						onClick={onClickMarkResidentResponsibility}
					>
						Mark as Resident Caused
					</Button>
				</div>
			) : (
				visibleCauses?.map((residentCause) => (
					<div
						key={residentCause.job_id}
						className="resident-responsibility-alert"
					>
						<p>
							<strong>
								{residentCause?.set_by_type === 'admin' ? 'Lula' : 'You'}{' '}
								{residentCause?.reason_for_change
									? 'edited the Resident Caused determination'
									: 'marked this Work Order resident caused'}
							</strong>
						</p>
						<p>
							{residentCause?.value === 'partially'
								? 'Partially Responsible'
								: 'Fully Responsible'}{' '}
							| {residentCause?.reason}
						</p>
						{residentCause?.reason_for_change ? (
							<p>Reason for Change: {residentCause?.reason_for_change}</p>
						) : null}
						<div className="resident-responsibility-alert__actions">
							<button
								type="button"
								className="resident-responsibility-alert__action-btn resident-responsibility-alert__action-btn"
								onClick={() => onClickEditResidentResponsibility(residentCause.job_id)}
							>
								<PenBlackIcon />
							</button>
							<button
								type="button"
								className="resident-responsibility-alert__action-btn resident-responsibility-alert__action-btn"
								onClick={() => onClickRemoveResidentResponsibility(residentCause.job_id)}
							>
								<TrashBlackIcon />
							</button>
						</div>
					</div>
				))
			)}
		</React.Fragment>
	);
};

export default ResidentResponsibility;
